import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { format,parse } from 'date-fns';
import { takeWhile } from "rxjs/operators";


import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";
import {DtgManageCarSearchComponent} from '../../../car';
import {DtgManageDriverSearchComponent} from '../../../driver';

@Component({
    templateUrl: './dtg.manage.schedule.drive.delete.component.html'
    ,providers: []
})
export class DtgManageScheduleDriveDeleteComponent implements OnInit,OnDestroy,AfterViewInit {

    isContinue:boolean = true;
    currentUserInfo:any;
    @Input() companyId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    checkRegDt:boolean = false;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    get f() { return this.formGroup.controls; }

    ngOnInit(): void {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                // this.checkSameId = true;
                // this.formGroup.disable();
                break;
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        this.isContinue = false;
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            dtgRegDtFrom:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgRegDtTo:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userId:null
            ,userNm:null
            ,dtgUnitId:null
            ,dtgCarNo:null
            ,drivePathNm:null
            ,drivePathFromNm:null
            ,drivePathToNm:null
        });
    }

    changeDtgRegDate(e) {

    }

    clickOpenModalUserList(dtgActionType:DtgActionType) {
        let modalRef = this.modalService.open(
            DtgManageDriverSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.formGroup.patchValue({
                    userId : resultModal.userInfo.userId
                    ,userNm : resultModal.userInfo.userNm || resultModal.userInfo.userId
                });
            }
        });
    }

    clickOpenModalCarList(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.formGroup.patchValue({
                    dtgUnitId : resultModal.carInfo.dtgUnitId
                    ,dtgCarNo : resultModal.carInfo.dtgCarNo
                });
            }
        });
    }

    clickResetCar() {
        this.formGroup.patchValue({
            dtgUnitId : null
            ,dtgCarNo : null
        });
    }

    clickResetDriver() {
        this.formGroup.patchValue({
            userId : null
            ,userNm : null
        });
    }

    clickDelete() {
        this.onSubmit();
    }

    clickCancel() {
        this.activeModal.close({
            "result":"cancel"
        });
    }

    onSubmit(){
        this.submitted = true;
        // valid form data
        if (this.formGroup.invalid) {
            return;
        }
        let deleteUserCarRunInfo = {
            companyId : this.companyId
            ,dtgRegDtFrom:this.f.dtgRegDtFrom.value.replace("T", " ")
            ,dtgRegDtTo:this.f.dtgRegDtTo.value.replace("T", " ")
            ,userId:this.f.userId.value
            ,dtgUnitId:this.f.dtgUnitId.value
            ,dtgCarNo:this.f.dtgCarNo.value
            ,drivePathNm:this.f.drivePathNm.value
            ,drivePathFromNm:this.f.drivePathFromNm.value
            ,drivePathToNm:this.f.drivePathToNm.value
        }

        // 입력 값 검증
        if (this.f.dtgRegDtFrom.value > this.f.dtgRegDtTo.value) {
            this.checkRegDt = false;
            return;
        }
        this.checkRegDt = true;

        // 사용자 Confirm
        if( !confirm("전체 배차기록을 일괄 삭제하시겠습니까?")) {
            return;
        }

        this.fvmsApiDtgUserService.deleteInBulkDtgUserCarRun(deleteUserCarRunInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // this.reloadListItem();
                    // n건의 배차기록이 삭제되었습니다
                    alert("배차기록이 일괄 삭제되었습니다.");
                }
            });

        this.activeModal.close({
            "result":"ok"
        });

        return;
    }
}
